import ColorLegend from "./ColorLegend";
import Marks from "./Marks";

const MapContainer = ({
  countries,
  rawMapData,
  data,
  colorScale,
  maxValue,
}) => {
  if (!countries || !data || !rawMapData) {
    return <div className="loading-data-alert">Loading...</div>;
  }

  return (
    <div className="map-container">
      <Marks
        countries={countries}
        rawMapData={rawMapData}
        data={data}
        colorScale={colorScale}
      />
      <ColorLegend colorScale={colorScale} maxValue={maxValue} />
    </div>
  );
};

export default MapContainer;
